import { useMatch } from "react-router-dom";

import { AttentionBubble } from "@/components/Interface/AttentionBubble/AttentionBubble";
import { PortalNavigationItem } from "@/components/Layout/PortalShellConfig";
import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * Swaps in the filled/active icon variant for the current route and overlays
 * the attention bubble on the friends-with-benefits item. Shared by the
 * labelled nav rows and the collapsed icon-only Sidebar rail.
 */
export const NavIcon = ({
  item,
  showAttentionBubble,
}: {
  item: PortalNavigationItem;
  showAttentionBubble: boolean;
}) => {
  const match = useMatch(item.target + "/*");
  const isFriendsWithBenefits =
    item.target === portalRoutes.friendsWithBenefits.base;

  return (
    // some Menu*.svg paths ship a hardcoded fill (#fff or none-via-inherit)
    // instead of currentColor, so force it here rather than in each asset
    <span className="relative inline-flex [&_path]:fill-current">
      {match ? item.activeIcon : item.icon}
      {isFriendsWithBenefits && showAttentionBubble && <AttentionBubble />}
    </span>
  );
};
